import type { IChatWorkspaceInfo } from '@chain-zen/chat'
import { UserNameWithVerificationIcon } from '@chain-zen/chat'
import { Card, CardContent, CardHeader, CardTitle } from '@chain-zen/ui'
import React from 'react'

import type { ICompany } from '../../../types/company'
import type { IUserWithPrimaryWorkspace } from '../../../types/user'
import { UserAvatar } from '../../shared/user/user-avatar'
import { CompanyDetails } from '../company-details'

interface CarrierDetailsProps {
  user: IUserWithPrimaryWorkspace
  workspace: IChatWorkspaceInfo & { company: ICompany }
}

/**
 * CarrierDetails will display the details of the carrier who made the offer
 */
export const CarrierDetails = ({ user, workspace }: CarrierDetailsProps) => {
  const userInfo = {
    email: user.email || '',
    id: user.id,
    name: user.name,
    photo: user.photo,
    role: user.role
  }

  const company = workspace?.company

  return (
    <Card>
      <CardHeader>
        <CardTitle>Carrier Info</CardTitle>
      </CardHeader>

      <CardContent>
        <div className="flex space-x-2 items-start" key={user?.id}>
          {/* Pass the user's email and phone in user object to show the data in tooltip */}
          {!!user && (
            <UserAvatar
              size="xs"
              user={userInfo}
              workspace={{
                id: workspace.id ?? '',
                isVerified: workspace.isVerified ?? false,
                name: workspace.name
              }}
            />
          )}

          {!!user && (
            <div>
              <UserNameWithVerificationIcon
                showVerificationStatus={false}
                user={userInfo}
                workspace={workspace}
                fontSize="sm"
              />
              <span className="text-muted-foreground text-sm">{user.email}</span>
            </div>
          )}
        </div>

        {!!workspace?.isVerified && !!company && <CompanyDetails company={company} />}
      </CardContent>
    </Card>
  )
}
